import { paletteBase } from '@abg/kit-base';

import { CarDetailsPopoverStyling } from './car-details-popover.types';

export const cardDetailsPopoverWrapperStyling: CarDetailsPopoverStyling = {
  position: 'fixed',
  zIndex: 2,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: paletteBase.black300,
};

export const cardDetailsPopoverChildContainerStyling: CarDetailsPopoverStyling =
  (theme) => ({
    width: '100%',
    maxWidth: '400px',
    position: 'absolute',
    zIndex: 3,
    right: '2%',
    bottom: '100%',
    transform: 'translate(-50%, 0)',
    marginBottom: '4px',
    borderRadius: '4px',
    [theme.breakpoints.down('sm')]: {
      left: '50%',
      right: 'initial',
    },
    [theme.breakpoints.down(480)]: {
      marginBottom: 'initial',
    },
  });
